import { Bell } from 'lucide-react';
import { useState } from 'react';
import styles from './PushAtivarBanner.module.css';

type PushAtivarBannerProps = {
  bloqueada: boolean;
  ativando?: boolean;
  onAtivar: () => void;
};

export function PushAtivarBanner({ bloqueada, ativando = false, onAtivar }: PushAtivarBannerProps) {
  // So o celular recolhe a explicacao (CSS ate 768px); no desktop ela aparece sempre.
  const [detalhes, setDetalhes] = useState(false);
  const classeDetalhe = detalhes ? undefined : styles.detalheRecolhido;

  return (
    <div className={styles.banner} role="alert">
      <span className={styles.iconWrap} aria-hidden>
        <Bell size={20} strokeWidth={2.4} />
      </span>
      <div className={styles.copy}>
        {bloqueada ? (
          <>
            <strong>As notificações deste site estão bloqueadas no navegador.</strong>
            <span className={classeDetalhe}>
              Desbloqueie no cadeado da barra de endereço (Notificações → Permitir) e recarregue a
              página. Em janela anônima o navegador não permite notificações — use uma aba normal.
              Confira também o Windows: o modo <strong>Não perturbe</strong> (Assistente de
              concentração) impede os avisos mesmo com o site autorizado.
            </span>
          </>
        ) : (
          <>
            <strong>Ative as notificações do navegador para receber avisos do chat.</strong>
            <span className={classeDetalhe}>
              Elas são obrigatórias neste acesso. Depois de ativar, confira também o Windows: o modo{' '}
              <strong>Não perturbe</strong> (Assistente de concentração) bloqueia os avisos mesmo com
              o site autorizado.
            </span>
          </>
        )}
      </div>
      <button
        type="button"
        className={styles.acaoCelular}
        aria-expanded={detalhes}
        onClick={() => setDetalhes((v) => !v)}
      >
        {detalhes ? 'Ocultar' : 'Como ativar'}
      </button>
      <button
        type="button"
        className={styles.btn}
        onClick={onAtivar}
        disabled={ativando}
      >
        {bloqueada ? 'Tentar novamente' : 'Ativar notificações'}
      </button>
    </div>
  );
}
